export const config = {
  graphql: {
    url: process.env.REACT_APP_GRAPHQL_URL,
  },
};
